import { render, staticRenderFns } from "./holes-create-groups.vue?vue&type=template&id=43873ecd"
import script from "./holes-create-groups.vue?vue&type=script&lang=js"
export * from "./holes-create-groups.vue?vue&type=script&lang=js"
import style0 from "./holes-create-groups.vue?vue&type=style&index=0&id=43873ecd&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports